import {useEffectOnce} from 'usehooks-ts';

export const useBrowserContextMenu = () => {
    function enableContextMenu(e) {
        e.stopPropagation();
        return true;
    }

    useEffectOnce(() => {
        document.addEventListener('contextmenu', enableContextMenu, true);

        return () => {
            document.removeEventListener('contextmenu', enableContextMenu, true);
        };
    });
};
